import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedO365App from "./EmbeddedO365App";
const O365App = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("o365.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("o365.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "o365.app.requirements",
      components: {
        azureLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://portal.azure.com/#view/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/~/Overview" }),
        officeLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://www.office.com/" }),
        loggingLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://compliance.microsoft.com/auditlogsearch?viewid=Async%20Search" })
      }
    }
  ))), /* @__PURE__ */ React.createElement(EmbeddedO365App, null));
};
export default O365App;
